// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 43 ? "page-stylist" : chunkId) + "." + {"43":"1198da02","143":"40788471","181":"839eb457","453":"e1d0f178","545":"f9419abd"}[chunkId] + ".chunk.js";
};